import type { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx/lite'

type Props = ComponentPropsWithoutRef<'button'>

export function CircleIconContainer(props: Props) {
  const { children, className, ...rest } = props

  return (
    <button type="button" className={clsx('flex size-[64px] items-center justify-center rounded-full shadow-[0_2px_3px_0_rgba(0,0,0,0.12),0_1px_6px_2px_rgba(0,0,0,0.06)]', className)} {...rest}>
      {children}
    </button>
  )
}
